import React, { useEffect, useState } from 'react';
import { StudentLayout } from '../../components/layout/StudentLayout';
import StudentProgressDashboard from '../../components/student/StudentProgressDashboard';
import { studentExamApi } from '../../api/examApi';
import { toast } from 'sonner';
import { ViewCorrectedPaperButton } from '../../components/student/CorrectedPaperViewer';

export default function StudentProgressPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    studentExamApi.getMyLedger()
      .then((res) => setData(res.data))
      .catch(() => toast.error('Failed to load progress'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <StudentLayout title="My Progress">
      <div className="animate-fade-in space-y-6">
        <div>
          <h2 className="text-xl font-semibold text-slate-900 dark:text-white">My Progress</h2>
          <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">
            Your scores, attendance, and exam history over time
          </p>
        </div>

        <StudentProgressDashboard
          data={data}
          loading={loading}
          onDownloadSubmission={(submissionId) => studentExamApi.downloadMySubmission(submissionId)}
          renderCorrectedPaper={(r) => <ViewCorrectedPaperButton attemptId={r.attempt_id} />}
          historyLabel="Exam History"
          emptyHistoryMessage="No exam attempts yet."
        />
      </div>
    </StudentLayout>
  );
}
